module.exports = __webpack_public_path__ + "static/img/11.8a543ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/11.jpg
// module id = 9KQZ
// module chunks = 29